import axiosClient from '@/config/api/axios'
import { INTEGRATION_CONNECTIONS } from '@/config/api/endpoints'

/**
 * Disconnect an app. Destructive and deliberate — reconnecting afterwards
 * means a fresh OAuth consent, so this is never used as part of a re-auth.
 *
 * @param {{ connectionId: string, signal?: AbortSignal }} options
 */
export async function disconnectConnection({ connectionId, signal }) {
  const { data } = await axiosClient.delete(
    `${INTEGRATION_CONNECTIONS}/${encodeURIComponent(connectionId)}`,
    { signal },
  )
  return data
}
